export default __webpack_public_path__ + "static/media/atoken.a56f65dd.svg";